/* eslint-disable no-console */
import axios from 'axios';
import Fuse from 'fuse.js';
import {
  Hero, Loader, LoaderType, SearchFilter, UniLinkResponseInterface, UniLinkSearchFilterResult
} from 'member-web-shared-components';
import React from 'react';
import { UniResponseInterface, UniversitySearchProps } from '../../types/App';
import './UniversitySearch.scss';

export const HandleToggleInteraction = (showMenu: { (): void; (arg0: boolean): void; }, hideMenu: { (): void; (arg0: boolean | undefined): void; }) => {
  const { useCallback, useEffect, useRef } = React;
  const ref = useRef<HTMLDivElement>(null);

  const escapeListener = useCallback((e: KeyboardEvent) => {
    console.log('escapeListener');
    if (e.key === 'Escape') {
      hideMenu();
    }
  }, [hideMenu]);

  const clickListener = useCallback(
    (e: MouseEvent) => {
      if (ref.current) {
        if (!ref.current?.contains(e.target as Node)) {
          hideMenu(false);
        } else {
          showMenu(true);
        }
      }
    },
    [showMenu, hideMenu]
  );

  useEffect(() => {
    document.addEventListener('click', clickListener);
    document.addEventListener('keyup', escapeListener);
    return () => {
      document.removeEventListener('click', clickListener);
      document.removeEventListener('keyup', escapeListener);
    };
  }, [clickListener, escapeListener]);

  return ref;
};

const UniversitySearch = (props: UniversitySearchProps) => {
  const {
    componentId,
    title,
    description,
    backgroundColor,
    image,
    endPoint,
    noResultsText,
    noResultsUrl,
    placeholder
  } = props;

  const { useState, useEffect } = React;

  const [loading, setLoading] = useState(false);
  const [hasInteracted, setInteracted] = useState(false);
  const [data, setData] = useState([] as UniResponseInterface[]);
  const [results, setResults] = useState([] as UniResponseInterface[]);

  const showMenu = () => {
    setInteracted(true);
  };

  const hideMenu = () => {
    setInteracted(false);
  };

  const ref = HandleToggleInteraction(showMenu, hideMenu);

  useEffect(() => {
    const setInitalState = (
      response: UniResponseInterface[]
    ) => {
      setData(response);
      setLoading(false);
    };

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(endPoint);
        setInitalState(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [endPoint]);

  const searchItem = (query: string) => {
    const options = {
      shouldSort: true,
      includeMatches: true,
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 3,
      keys: ['terms']
    };

    const fuse = new Fuse(data, options);
    const results = fuse.search(query);
    const finalResults: UniResponseInterface[] = [];

    if (results.length) {
      results.forEach((item: { item: UniResponseInterface; }, index: number) => {
        if (index < 5) {
          finalResults.push(item.item);
        }
      });
      setResults(finalResults);
    } else {
      setInteracted(true);
      setResults([]);
    }
  };

  return (
    <div
      data-testid={componentId}
      className='university-search'
    >
      <Hero
        title={title}
        description={description}
        backgroundColor={backgroundColor}
        image={image}
        extraClass='mwsc-hero__presales'
      >
        {data.length === 0 || loading ? (
          <Loader loading loaderType={LoaderType.SIMPLE} loaderClasses='light small'>
            <span data-testid='zipcar-react-components-loading' />
          </Loader>
        ) : (
          <div ref={ref}>
            <SearchFilter
              searchItem={searchItem}
              results={results}
              hasInteracted={hasInteracted}
              noResultsText={noResultsText}
              noResultsUrl={noResultsUrl}
              placeholder={placeholder}
              keyName='presales-uni-seach'
            >

              <UniLinkSearchFilterResult result={{} as UniLinkResponseInterface} />
            </SearchFilter>
          </div>
        )}
      </Hero>
    </div>
  );
};

export default UniversitySearch;
